type CrownIconProps = {
    className?: string;
};

export default function CrownIcon({ className }: CrownIconProps) {
    return (
        <svg
            viewBox="0 0 64 64"
            aria-hidden="true"
            className={className}
            role="img"
        >
            <path
                d="M7 51h50l6-31L48 29 32 10 16 29 1 20l6 31z"
                fill="currentColor"
                opacity="0.85"
            />
            <path
                d="M6 51h52v6H6z"
                fill="currentColor"
                opacity="0.35"
            />
        </svg>
    );
}
